import styled, { css } from "styled-components";

export const Container = styled.div`

width: 100%;

.h2{
    font-size: 24px;
    line-height: 30px;
    color: #fff !important;
    strong, p ,h2{
        color: #fff !important;  
    }
    @media (max-width: 750px) {
      
        font-size: 18px;
        line-height: 22px;
  }
}

.p{
   
    font-size: 16px;
    line-height: 22px;
    @media (max-width: 750px) {
      
        font-size: 12px;
        line-height: 16px;
  }

  p{
    font-size: 16px;
    line-height: 22px;
    @media (max-width: 750px) {
      
        font-size: 12px;
        line-height: 16px;
  }  
  }
 
}

`;

interface IProps {
    color: string;
    background: string;
    numberColor: string;
    numberBackground: string;
}

export const ItemDiv = styled.div<IProps>`
    
    display: flex;
    flex-direction: column;
    position: relative;
    transition: 0.5s all;
    justify-content: flex-start;
    align-items: flex-start;
    cursor: pointer;

    transition: 0.5s all;
    background: rgb(2,0,36);
background: none;
     
  
        font-size: 14px;
     
  color: #333;
        padding: 15px 30px;
        width: 100%;
        max-width:400px;
 
        width: 100%;

    
    &:hover{
        transform: scale(1.01);
 
        >h2{
            border-color:  #333 !important;
            
        }
    }


    >nav{
        padding: 20px;
        border-radius: 10px;
        background: #ddd;
        z-index: 100;
        flex-grow: 1;
        ${props => props.background && css`
        backdrop-filter : blur(20px);
    background :  ${props.background} !important;
    `}

    ${props => props.color && css`
    
    color :  ${props.color} !important;
    `}

    }

>div{
    transition: 0.5s all;
    align-self: flex-start;
    margin-right: -10px;
    font-weight: bold;
    background-color:  rgb(0,250,0) !important;
box-shadow: 0px 0px 15px  rgba(0,250,0,0.7) !important;
    backdrop-filter : blur(11px);
    font-size: 28px;
    color: rgb(2, 28, 60);
    display: flex ;
    align-items: center;
    justify-content: center;
    padding: 10px;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin-left: -30px;
    margin-bottom: -10px;
    z-index: 0;

    ${props => props.numberColor && css`
    
    color :  ${props.numberColor} !important;
    `}

    ${props => props.numberBackground && css`
    
    background :  ${props.numberBackground} !important;
    box-shadow: 0px 0px 15px  ${props.numberBackground} !important;
`}
}
h2{
    margin-bottom: 10px;
}
  
p, h2{
    color :  #333 !important;
    font-size: 14px;

    ${props => props.color && css`
    
    color :  ${props.color} !important;
    `}
}

`